import router from '@/router/app';
import { Query, Route } from '@/router/app/types';

export default class RouterHelper {
  public static getQuery(currentRoute: Route = router.currentRoute): Query {
    return currentRoute.query;
  }

  public static deleteQueryParams(paramNames: string[], doUseHistory = false): Promise<Route> {
    const query = { ...router.currentRoute.query };
    // Must assign undefined value to delete get param
    // @ts-ignore
    paramNames.forEach((name) => (query[name] = undefined));

    if (doUseHistory) {
      return router.push({ query });
    }
    return router.replace({ query });
  }
}
